import React, { useEffect, useState } from "react";
import { View } from "react-native";

import tw from "../../styles/tailwind";

import Text from "../Text";
import Toggle from "../Toggle";

import { useController } from "react-hook-form";


export default function LabelSwitch({ label, onChange, value, control, name, style, onValue=true, offValue=false }) {
  const [isEnabled, setIsEnabled] = useState(value);

  var { field, fieldState: { invalid, isTouched, isDirty, error } } = useController({
    control: control,
    defaultValue: isEnabled ? onValue : offValue,
    name: name,
  })

  function toggleSwitch() {
    setIsEnabled(previousState => !previousState);
    onChange && onChange( ! isEnabled ? onValue : offValue )
    field.onChange( ! isEnabled ? onValue : offValue )
  }
    

  useEffect(() => {

    const state = field.value == onValue? true : false
    setIsEnabled(state)
  }, [])

  return (
    <View style={tw.style(`flex-row items-center px-5 h-14 rounded-lg`, "bg-gray-50", style?.container, isEnabled && style?.enabledStyle)}>
      <Text style={tw.style( isEnabled ? "text-gray" : "text-gray-400" ,style?.label)}>{label}</Text>

      <Toggle
        onValueChange={toggleSwitch}
        value={isEnabled}
        style={tw`absolute right-3`}
      />
    </View>
  )
}